import React from "react";
import { Link } from "react-router-dom";

const SubmissionSuccess = () => {
  return (
    <div className="min-h-screen h-full xsm:fixed flex w-full items-center justify-center absolute rejection-card flex-col">
      <div className="flex flex-col gap-3 bg-white w-[80%] rounded-2xl items-center justify-center py-9 ">
        <span>Your application has been submitted!</span>
        <Link to="/dashboard/jobs" className="btn btn-success">
          Continue to Job search
        </Link>
      </div>
    </div>
  );
};

export default SubmissionSuccess;
